ACC.imagegallery = {

    _autoload: [
        'bindImageGallery',
    ],

    bindImageGallery() {
        $('.js-gallery').each(function () {
            const $image = $(this).find('.js-gallery-image');
            const $carousel = $(this).find('.js-gallery-carousel');

            // main 'stage'
            $image.each(function () {
                if ($(this).closest('.modal-content--container-altMethod').length === 0) {
                    $image.owlCarousel({
                        singleItem: true,
                        autoHeight: true,
                        pagination: false,
                        navigation: false,
                        mouseDrag: false,
                        touchDrag: false,
                        addClassActive: true,
                        afterMove: true,
                        lazyLoad: true,
                        afterLazyLoad() {
                            const b = $image.data('owlCarousel') || {};
                            if (!b.currentItem) {
                                b.currentItem = 0;
                            }
                        },

                        afterInit() {
                            /*  Magic Box customizations

                        Note: only for carousels rendered
                        inside .magic-box__media (program page)
                        ======================================= */
                            const mbGallery = $('.magic-box__media').find('.js-gallery');
                            // eslint-disable-next-line max-len
                            const mbGalleryWrapper = $('#magic-box').find('.image-gallery__image').find('.owl-wrapper-outer');

                            // make visible once DOM changes are complete
                            mbGallery.addClass('is-visible');

                            // insert expander control
                            if (!$('.magic-box__img-expander').length) {
                                mbGalleryWrapper
                                    // eslint-disable-next-line max-len
                                    .prepend('<a href="javascript:void(0)" class="magic-box__img-expander" target="_blank" rel="noopener noreferer"><span class="screenreader">Expand image in modal/new tab/new window"</span><i aria-hidden="true"></i></a>');
                            }
                        },

                        afterAction() {
                            ACC.imagegallery.syncPosition($image, $carousel, this.currentItem);

                            /*  Magic Box customizations

                        Note: only for carousels rendered
                        inside .magic-box__media (program page)
                        ======================================= */

                            if ($('.magic-box__media').length > 0) {
                                const mbGalleryStage = $('.magic-box__media').find('.js-gallery-image');
                                const mbActiveStageItem = mbGalleryStage.find('.owl-item.active');
                                const mbActiveSrc = mbActiveStageItem.find('img.lazyOwl').attr('data-superzoom-src');
                                const mbExpander = mbGalleryStage.find('.magic-box__img-expander');

                                mbExpander.attr('href', mbActiveSrc);
                            }
                        },

                    });
                }
            });

            // thumbnail img nav
            $carousel.owlCarousel({
                navigation: false,
                pagination: false,
                mouseDrag: false,
                touchDrag: false,
                items: 4,
                itemsDesktop: false,
                itemsDesktopSmall: false,
                itemsTablet: false,
                itemsTabletSmall: false,
                itemsMobile: false,
                lazyLoad: true,
            });

            $carousel.on('click', 'a.item', function (e) {
                e.preventDefault();
                $image.trigger('owl.goTo', $(this).parent('.owl-item').data('owlItem'));
            });
        });
    },

    syncPosition() {
        // ensure active item in thumbnav remains in sync with stage
        if ($('.magic-box__media').length > 0) {
            const mbMedia = $('.magic-box__media');
            const mbExpander = $('.magic-box__img-expander');
            const modalImg = $('.modal-media--img');
            const mbGallery = mbMedia.find('.js-gallery-image');
            const activeMedia = mbGallery.find('.owl-item.active');
            const activeMediaImg = activeMedia.find('img.lazyOwl');
            const activeMediaSrc = activeMediaImg.attr('data-superzoom-src');
            const activeMediaAlt = activeMediaImg.attr('alt');

            mbExpander.attr('href', activeMediaSrc);

            modalImg
                .attr({
                    src: activeMediaSrc,
                    alt: activeMediaAlt,
                });
        }
    },
};
